<template>
  <div>
    <h1 class="display-1 font-weight-bold mx-1 mb-3">Artwork Board</h1>
    <v-btn @click="onClick()">Click</v-btn>
    <!-- <div v-if="showResults">
      <p>
        This following contacts will be synced
      </p>
      <v-divider class="mt-4"></v-divider>
      <v-data-table
        :headers="headers"
        :items="updates"
        :disable-pagination="true"
        :hide-default-footer=true
        :loading="loadingData"
        loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.contact`]="{ item }">
            {{item.firstName}} {{item.lastName}}
        </template>
        <template v-slot:[`item.i`]="{ item, index }">
            {{index + 1}}
        </template>
      </v-data-table>
    </div> -->
  </div>
</template>

<script>
import TrelloApi from "@/api/admin/trello";
import ContactApi from "@/api/contact";
const boardId = process.env.VUE_APP_TRELLO_ARTWORK_BOARD_ID || "";
console.log("board", boardId);
export default {
  props: {},
  components: {},
  data() {
    return {
      selectedFile: null,
      board: null,
      boards: [],
      boardLists: [],
      contacts: [],
    };
  },
  async created() {
    TrelloApi.getBoards().then((boards) => (this.boards = boards));
    TrelloApi.getBoard(boardId).then((board) => (this.board = board));
    TrelloApi.getBoardLists(boardId).then((boardLists) => (this.boardLists = boardLists));
  },
  methods: {
    onClick() {
      console.log("test");
    },
  },

  computed: {},
  watch: {},
};
</script>
